import { IncomeWealthService } from './../../income-wealth/service/income-wealth.service';
import {Component, OnInit} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {NavController} from '@ionic/angular';
import { AnalyticsPageService } from '../../shared/service/analytics/analytics-page.service';
import { AnalycticsNativeService } from '../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { RadioModel } from '../../personal-data/model/radio.model';
import { AnalyticsPageModel } from '../../shared/model/analyticsPage';
import { DefaultPageComponent } from '../../shared/page/default-page.component';
import { BackNativeService } from '../../shared/service/comunicator-native/back-native/back-native';
import { ReturnNativeService } from '../../shared/service/comunicator-native/return-native/return-native';
import { JourneyService } from '../../shared/service/journey/journey.service';
import { AnalyticsGA4PageService } from '../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';
import { AnalyticsGA4PagesModel } from '../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';

@Component({
  selector: 'app-investiment-broker',
  templateUrl: './investiment-broker.component.html',
  styleUrls: ['./investiment-broker.component.scss'],
})
export class InvestimentBrokerComponent extends DefaultPageComponent implements OnInit {

  headerId = 'broker';
  idLink = 'saiba-mais-vinculo';
  selectedItem: string;
  selectedItemCode: string;
  selectedName = '';
  buttonEnable = false;
  idLabel = 'page-investiment-broker';
  ariaLabelLink = 'Saiba mais sobre pessoas vinculadas';
  titlePage = 'Vínculo com a Itaú Corretora';
  dataDomain: RadioModel[];
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  investimentBrokerType = [
    {
      key: 'Sim',
      value: 'Sim',
      ariaLabel: 'Sim',
    },
    {
      key: 'Não',
      value: 'Não',
      ariaLabel: 'Não',
    }
  ];
  dataDetail = {
    index: this.idLink,
    title: 'pessoas vinculadas',
    description: `
    <p class="text-mrb-sm">Nos termos da legislação aplicável, são consideradas pessoas vinculadas à Itaú Corretora:</p>
    <p class="text-mrb-sm">(a) administradores, empregados, operadores e demais prepostos da Itaú Corretora que desempenhem
    atividades de intermediação ou de suporte operacional;</p>
    <p class="text-mrb-sm">(b) agentes autônomos que prestem serviços à Itaú Corretora;</p>
    <p class="text-mrb-sm">(c) demais profissionais que mantenham, com a Itaú Corretora, contrato de prestação de serviços
    diretamente relacionados à atividade de intermediação ou de suporte operacional;</p>
    <p class="text-mrb-sm">(d) pessoas naturais que sejam, direta ou indiretamente, controladoras ou participem do controle
    societário da Itaú Corretora;</p>
    <p class="text-mrb-sm">(e) sociedades controladas, direta ou indiretamente, pela Itaú Corretora ou por pessoas a ela vinculadas;</p>
    <p class="text-mrb-sm">(f) cônjuge ou companheiro e filhos menores das pessoas mencionadas nas alíneas “a” a “d” acima;</p>
    <p class="text-mrb-sm">(g) clubes e fundos de investimento cuja maioria das cotas pertença a pessoas vinculadas, salvo
    se geridos discricionariamente por terceiros não vinculados.</p>
    `
  };

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    private analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private incomeWealthService: IncomeWealthService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
  }

  ionViewWillEnter() {
    this.focusPageWithDetail(this.dataDetail.index);
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  changeItem(event) {
    if (event) {
      this.buttonEnable = true;
    } else {
      this.buttonEnable = false;
    }
  }

  getPageId(): string {
    return this.headerId;
  }

  openDetail() {
    this.analyticsEventCliqueSaibaMais();
    this.router.navigateForward('details', { state: {
      data: {
        ...this.dataDetail,
        analyticsPage: {
          pageName: this.analyticsPage?.relatedPerson,
          action: this.analyticsPage?.action,
          back: this.analyticsPage?.back,
        },
        analyticsPageGA4: {
          paramDefautl: {
            event_name: this.analyticsPageGA4.eventNameScreenView,
            custom_path: this.analyticsPageGA4.customPathPessoasVinculadas,
            implementation_team: this.analyticsPageGA4.implementationTeam,
          }
        }
      }
    } });
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    // tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage?.broker;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  analyticsEventClique() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
      it_eventaction: this.analyticsPage?.action,
      it_eventlabel: this.analyticsPage?.back,
      it_pagename: this.analyticsPage?.broker
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  analyticsEventCliqueSaibaMais() {
    const it_eventcategory = 'Clique';
    const it_complementary = {
      it_eventaction: this.analyticsPage?.action,
      it_eventlabel: this.analyticsPage?.knowMore,
      it_pagename: this.analyticsPage?.broker
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathVinculoCorretora,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

  clickNext() {
    this.incomeWealthService.setPersonLinkedToTheBrokerage(this.selectedItem === 'Sim' ? true : false);
    this.nextPage();
  }

  setEditPageRegistratio() {
    if (typeof this.journeyService.registratioJourney?.data.incomeEquity.personLinkedToTheBrokerage === 'boolean') {
      this.selectedItem = this.journeyService.registratioJourney.data.incomeEquity.personLinkedToTheBrokerage
      ? 'Sim' : 'Não';
      this.selectedName = this.journeyService.registratioJourney.data.incomeEquity.personLinkedToTheBrokerage
      ? 'Sim' : 'Não';
      this.buttonEnable = true;
    }
  }

}
